import { Box } from '@mui/material';
import animationData from 'assets/lottie/Loading-Paper-Plane.json';
import { FC } from 'react';
import Lottie from 'lottie-react';

interface LoadingPaperPlaneProps {
    width?: number;
    height?: number;
}

export const LoadingPaperPlane: FC<LoadingPaperPlaneProps> = ({ width = 100, height = 100 }) => {
    return (
        <Box className="w-full flex justify-center items-center">
            <Lottie animationData={animationData} style={{ width: width, height: height }} loop={true} autoplay={true} />
        </Box>
    );
};
